import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CreateRaffle from './pages/CreateRaffle';
import RaffleDetails from './pages/RaffleDetails';
import PublicRaffle from './pages/PublicRaffle';
import Pricing from './pages/Pricing';
import Welcome from './pages/Welcome';
import SubscriptionManagement from './pages/SubscriptionManagement';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Support from './pages/Support';
import { AuthProvider, useAuth } from './context/AuthContext';

function PrivateRoute({ children }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/raffle/:id" element={<PublicRaffle />} />

          {/* Legal Pages */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/support" element={<Support />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <PrivateRoute><Dashboard /></PrivateRoute>
          } />
          <Route path="/raffles/create" element={
            <PrivateRoute><CreateRaffle /></PrivateRoute>
          } />
          <Route path="/raffles/:id" element={
            <PrivateRoute><RaffleDetails /></PrivateRoute>
          } />
          <Route path="/subscription" element={
            <PrivateRoute><SubscriptionManagement /></PrivateRoute>
          } />

          {/* Admin Routes */}
          <Route path="/admin" element={
            <PrivateRoute><AdminDashboard /></PrivateRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
